import React from 'react';
import { notification } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import FormDepositoContravencion from './FormDepositoContravencion';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import insertDepositoContravencion from '../../../graphql/mutations/contravenciones/insertDepositoContravencion.graphql';

@compose(
  graphql(getUsuario),
  graphql(insertDepositoContravencion, {
    name: 'insertDepositoContravencion',
  })
)
class CargarDeposito extends React.Component {
  onSubmit = e => {
    e.preventDefault();
  };

  crearDeposito = deposito => {
    // deposito.idOrganismo = this.props.data.getUsuario.organismo._id;

    this.props
      .insertDepositoContravencion({
        variables: { objDeposito: deposito },
      })
      .then(res => {
        if (res.data.insertDepositoContravencion) {
          notification.success({
            message: 'Deposito de Contravencion Registrado',
            description:
              'El deposito se registró correctamente en la base de datos',
          });

          this.props.history.push('/');
        }
      })
      .catch(err => {
        console.log('Se ha producido un error');
        console.log(err);
        notification.error({
          message: 'Error al registrar el deposito de contravencion',
          description:
            'Se ha producido un error al registrar el deposito de contravencion',
        });
      });
  };

  render() {
    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    if (!data.getUsuario) {
      return null;
    }

    return (
      <div>
        <h1 className="tituloForm">Administración General</h1>

        <FormDepositoContravencion onSubmit={this.crearDeposito} />
      </div>
    );
  }
}

export default Form.create()(withApollo(CargarDeposito));
